import { render, staticRenderFns } from "./authors.vue?vue&type=template&id=3cbd7821"
import script from "./authors.vue?vue&type=script&lang=ts"
export * from "./authors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports